import { render, staticRenderFns } from "./PublicProductLink.vue?vue&type=template&id=d59c5442&scoped=true&"
import script from "./PublicProductLink.vue?vue&type=script&lang=js&"
export * from "./PublicProductLink.vue?vue&type=script&lang=js&"
import style0 from "./PublicProductLink.vue?vue&type=style&index=0&id=d59c5442&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59c5442",
  null
  
)

export default component.exports